import script from "./Bubbles.vue?vue&type=script&setup=true&lang=js"
export * from "./Bubbles.vue?vue&type=script&setup=true&lang=js"

import "./Bubbles.vue?vue&type=style&index=0&id=738e7c84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738e7c84"]])

export default __exports__